import { FC, useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import useCookies from "../../hooks/useCookies";
import useShallowSelector from "../../hooks/useShalowSelector";
import Icon, { IconTypes } from "../../libs/Icon";

interface IProps {
    onClose(): void;
}

const UserOptions: FC<IProps> = ({ onClose }) => {
    const userOprionsRef = useRef(null);
    const { setTokens } = useCookies();
    const [isMounted, setIsMounted] = useState(true);
    const userData = useShallowSelector(state => state.auth.user);

    const logOut = () => {
        localStorage.clear();
        setTokens("", "");
    };
    const handleDocumentClick = useCallback(
        (e: Event) => {
            if (
                isMounted &&
                userOprionsRef.current &&
                !ReactDOM.findDOMNode(userOprionsRef.current)?.contains(e.target as Node)
            )
                onClose();
        },
        [onClose, userOprionsRef, isMounted],
    );

    useEffect(() => {
        document.addEventListener("click", handleDocumentClick);
        document.addEventListener("touchend", handleDocumentClick);

        return () => {
            document.removeEventListener("click", handleDocumentClick);
            document.removeEventListener("touchend", handleDocumentClick);
        };
    }, [handleDocumentClick]);

    useEffect(() => {
        setIsMounted(true);
    }, []);
    const goToProfileSettings = () => {
        window.open("https://user.boomform.com", "__blank");
    };
    const goToSupport = () => {
        window.open("https://boomform.com/support", "__blank");
    };
    const goToDashboard = () => {
        window.open("https://dashboard.boomform.com", "__blank");
    };

    return (
        <div className={styles.userOptions} ref={userOprionsRef}>
            <div>
                <div className={styles.infoBox}>
                    <div className={styles.image_outer_circle}>
                        <div className={styles.image_inner_circle}>
                            {userData?.pic ? <img src={userData.pic} alt="user_image" /> : userData?.name.split("")[0]}
                        </div>
                    </div>

                    <div className={styles.personalInfo_block}>
                        <span className={styles.name}>{userData?.name}</span>
                        <span className={styles.email}>{userData?.email}</span>
                    </div>
                    <div className={styles.buttons_block}>
                        <button className={styles.bussines_btn}>Bussines</button>
                        <button className={styles.upgrade_btn}>Upgrade</button>
                    </div>
                </div>

                <div className={styles.settings_block}>
                    <button onClick={goToProfileSettings}>
                        <Icon className={styles.settings_block_item} type={IconTypes.USER_SETTINGS}>
                            Profile settings
                        </Icon>
                    </button>
                    <button onClick={goToSupport}>
                        <Icon className={styles.settings_block_item} type={IconTypes.MESSAGE}>
                            Help center
                        </Icon>
                    </button>
                    <button onClick={goToDashboard}>
                        <Icon className={styles.settings_block_item} type={IconTypes.ARROW_RIGHT}>
                            View entries
                        </Icon>
                    </button>
                </div>

                <div className={styles.log_out_block}>
                    <a href="https://editor.boomform.com" className={styles.log_out_btn} onClick={logOut}>
                        <Icon type={IconTypes.LOG_OUT} /> Log Out
                    </a>
                </div>
            </div>
        </div>
    );
};

export default UserOptions;
